module.exports = __webpack_public_path__ + "img/LNB_home.00e10c8c.svg";